import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useReduxUserSync = () => {
    const auth = useAuth();
    const dispatch = useDispatch();
    const userInStore = useSelector((state) => state.auth.user); // Get user from Redux
    useEffect(() => {

        if(!auth.isLoading && auth.isAuthenticated && !userInStore){
            const profile = auth.user?.profile;
            if(!profile) return;
            const rawGroups = profile['cognito:groups'] || [];
            const roles = rawGroups.map(g => g.toLowerCase());

            const userData = {
                id: profile.sub,
                email: profile.email,
                username: profile['cognito:username'],
                phone_number: profile.phone_number,
                resource_id: profile['custom:resource_id'],
                roles: roles.length > 0 ? roles : ['patrol'],
                loggedInAt: Date.now(),
                tokens: {
                    id_token: auth.user?.id_token,
                    access_token: auth.user?.access_token,
                    refresh_token: auth.user?.refresh_token
                },
            };
            dispatch({type: 'auth/setUser', payload: userData});
        }
    }, [auth.isLoading, auth.isAuthenticated, auth.user, userInStore, dispatch]);
}